.workspace-button{width:136px;height:40px}.workspace-button.loading-button{font-size:0}
/*# sourceMappingURL=stop-work-button.component.css.map */
